export const orderByField = (key, order) => (a, b) =>
  order && order.length ? order.indexOf(a[key]) - order.indexOf(b[key]) : 0
